import React from "react"
import { Col } from "react-bootstrap"

function FormLabel({ text, asterisk }) {
  return (
    <Col xs={12} md={6} className="textforinput marginTop10px">
      <p>{text}  {asterisk !== undefined && asterisk == true && (<span style={{color: "red"}}>&nbsp;*</span>)}</p>
    </Col>
  )
}
export default FormLabel
